import { createContainer } from 'react-sweet-state';

import { BrandVoicesStore } from './BrandVoicesStore';

export const BrandVoicesStoreContainer = createContainer(BrandVoicesStore, {
  onInit:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
});
